// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { useEffect, useLayoutEffect, useRef } from "react";

export function useClickAway(cb: any) {
    const ref = useRef(null);
    const refCb = useRef(cb);

    useLayoutEffect(() => {
        refCb.current = cb;
    });

    useEffect(() => {
        const handler = (e: any) => {
            const element = ref.current as any;
            if (element && !element.contains(e.target)) {
                refCb.current(e);
            }
        };

        document.addEventListener("mousedown", handler);
        document.addEventListener("touchstart", handler);

        return () => {
            document.removeEventListener("mousedown", handler);
            document.removeEventListener("touchstart", handler);
        };
    }, []);

    return ref;
}
